// frontend/src/api/accessProvisioning.js

async function parseResponse(res) {
  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");

  const payload = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    // Prefer a backend-provided message; otherwise fall back to status line / payload
    const detail = isJson && payload ? payload.detail : null;

    const message =
      (isJson && payload && payload.message) ||
      (typeof detail === "string" && detail) ||
      (detail && typeof detail === "object" && (detail.error || JSON.stringify(detail))) ||
      (typeof payload === "string" && payload) ||
      `${res.status} ${res.statusText}`;

    throw new Error(message);
  }

  return payload;
}

/**
 * GET /api/organizations
 * Expected response: [{ id: number, name: string }]
 */
export async function getOrganizations() {
  const res = await fetch("/api/organizations", {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });

  return parseResponse(res);
}

/**
 * POST /api/organizations/:orgId/customer-user/remove
 * Body: { email: string }
 */
export async function removeCustomerUser(orgId, email) {
  if (!orgId) throw new Error("orgId is required");
  if (!email) throw new Error("email is required");

  const res = await fetch(`/api/organizations/${orgId}/customer-user/remove`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });

  return parseResponse(res);
}

/**
 * POST /api/organizations/:orgId/customer-user/reactivate
 * Body: { email: string }
 */
export async function reactivateCustomerUser(orgId, email) {
  if (!orgId) throw new Error("orgId is required");
  if (!email) throw new Error("email is required");

  const res = await fetch(`/api/organizations/${orgId}/customer-user/reactivate`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });

  return parseResponse(res);
}

/**
 * POST /api/organizations/:orgId/admin-user
 * Body: { email: string, name?: string, sendPasswordReset: boolean }
 */
export async function ensureAdminUser(orgId, { email, name, sendPasswordReset }) {
  if (!orgId) throw new Error("orgId is required");
  if (!email) throw new Error("email is required");

  const res = await fetch(`/api/organizations/${orgId}/admin-user`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      name: name || undefined,
      sendPasswordReset: Boolean(sendPasswordReset),
    }),
  });

  return parseResponse(res);
}
